import assetPath from '/app/packages/login/layout/src/background-layout/images/background.png';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')